import Column from "@amzn/meridian/column";
import Expander from "@amzn/meridian/expander";
import Heading from "@amzn/meridian/heading";
import Link from "@amzn/meridian/link";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { observer } from "mobx-react-lite";
import React from "react";
import { useState } from "react";

import { FAQInfo } from "../constants/FAQs";
import { borderStyle } from "../styles/Style";
import { IFAQsContainerProps, IFAQsList } from "../types/FAQs.types";

const ControlledExpander = (props) => {
  const [isControlledExpanderOpen, setIsControlledExpanderOpen] =
    useState<boolean>(false);

  return (
    <Expander
      open={isControlledExpanderOpen}
      onChange={setIsControlledExpanderOpen}
      {...props}
    />
  );
};

const FAQContainer = ({
  responseWidth,
  faqsList,
  headingLevel = 5,
  textType,
}: IFAQsContainerProps) => {
  const { FAQ_HEADING } = FAQInfo;

  return (
    <Column
      width={responseWidth || "100%"}
      spacingInset="300 400"
      data-testid="faqcontainer-main-column"
    >
      <Heading level={headingLevel} data-testid="faqcontainer-title-heading">
        {FAQ_HEADING}
      </Heading>
      <Column
        width="100%"
        className={borderStyle}
        data-testid="faqcontainer-list-column"
      >
        {faqsList.map(({ answer, question, link }: IFAQsList) => (
          <Row
            key={answer}
            width="100%"
            data-testid={`faqcontainer-item-row-${answer.substring(0, 20).toLowerCase().replace(/\s+/g, "-")}`}
          >
            <ControlledExpander
              title={
                <Text
                  color="secondary"
                  type={textType}
                  data-testid={`faqcontainer-question-text-${answer.substring(0, 20).toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {question}
                </Text>
              }
              type="list"
            >
              <Text
                data-testid={`faqcontainer-answer-text-${answer.substring(0, 20).toLowerCase().replace(/\s+/g, "-")}`}
                type={textType}
              >
                {answer}&nbsp;
                <Link
                  type="secondary"
                  href={link}
                  data-testid={`faqcontainer-link-${answer.substring(0, 20).toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {link}
                </Link>
              </Text>
            </ControlledExpander>
          </Row>
        ))}
      </Column>
    </Column>
  );
};

export default observer(FAQContainer);
